import { TableCellProps } from "@mui/material";
import React from "react";
import { AuditModel } from "../../pages/shared/models/AuditModel";
import { HistoryTableColumn, HistoryTableColumnTypes } from "./history-table-column.model";
import BarekamText from "../../pages/components/text";
import { OrderTableCell, OrderTableRow } from "../../pages/orders/my/order-list/styled";
import Message from "../../pages/components/message";
import { MessageSections } from "../../pages/components/message/message";
import moment from "moment";
import { useAppSelector } from "../../redux/store";

export const HistoryRow = (props: HistoryTableRowProps) => {
    const { languageId } = useAppSelector(state => state.messagesReducer);

    return (
        <OrderTableRow tabIndex={props.index}>
            {props.columns.map((column, columnIndex) => (
                <OrderTableCell key={`${props.index}-${columnIndex}`}
                    style={{ height: '3rem' }}>
                    <CellContent languageId={languageId} column={column} {...props} />
                </OrderTableCell>
            ))}
        </OrderTableRow>
    )
}

const UpdatedFieldContent = ({ field, value, languageId }: UpdatedFieldContentProps) => {
    switch (field) {
        case 'defaultDeliveryWarehouseId':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value}`}
                </BarekamText>
            )
        case 'warehouse':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value?.name}`}
                </BarekamText>
            )
        case 'locationId':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value?.name[languageId]}`}
                </BarekamText>
            )
        case 'status':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value?.name}`}
                </BarekamText>
            )
        case 'paymentStatus':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value?.name}`}
                </BarekamText>
            )
        case 'trackRecord':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value[0]?.state?.name}`}
                </BarekamText>
            )
        case 'order':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value?.orderId || ''} ${value?.name ? ', ' + value.name : ''} ${value?.trackingNumber ? ', ' + value.trackingNumber : ''}`}
                </BarekamText>
            )
        case 'city':
        case 'country':
        case 'province':
        case 'region':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value && value.name ? value?.name[languageId] : ''}`}
                </BarekamText>
            )
        case 'updatedOn':
        case 'updatedBy':
            return (
                <></>
            )
        case 'expectedDate':
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${moment(value).format('DD/MM/YYYY HH:mm')}`}
                </BarekamText>
            )
        default:
            return (
                <BarekamText variant={"m"}>
                    {`${field}: ${value ? typeof value === 'string' ? value : value[languageId] : ''}`}
                </BarekamText>
            )
    }
}

const CellContent = ({ column, row, languageId }: HistoryTableCellProps) => {
    switch (column.variant) {
        case HistoryTableColumnTypes.USER_NAME:
            return (
                <BarekamText variant={"m"}>
                    {`${row?.updatedBy?.firstName || ''} ${row?.updatedBy?.lastName || ''}`}
                </BarekamText>
            )
        case HistoryTableColumnTypes.OPERATION:
            return (
                <BarekamText variant={"m"}>
                    <Message messageKey={row.operationType} sectionId={MessageSections.MAIN} />
                </BarekamText>
            )
        case HistoryTableColumnTypes.COLLECTION_NAME:
            return (
                <BarekamText variant={"m"}>
                    {row.collectionName}
                </BarekamText>
            )
        case HistoryTableColumnTypes.UPDATED_FIELDS:
            return (
                <div>
                    {row.updatedFields && (
                        Object.keys(row.updatedFields).map(field =>
                            <UpdatedFieldContent field={field} value={row.updatedFields[field]} languageId={languageId} />
                        )
                    )}
                </div>
            );
        case HistoryTableColumnTypes.DATE:
            return (
                <BarekamText variant={"m"} align={'left'}>
                    {moment(row.updatedOn).format('DD/MM/YYYY HH:mm:ss')}
                </BarekamText>
            )
        default:
            return <></>
    }
}

interface HistoryTableRowProps extends TableCellProps {
    columns: HistoryTableColumn[],
    row: AuditModel;
    index: number,
}

interface HistoryTableCellProps {
    column: HistoryTableColumn,
    row: AuditModel;
    languageId: number;
}

interface UpdatedFieldContentProps {
    field: string,
    value: any;
    languageId: number;
}